import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import InvoicesList from "../../../Billing/Invoices/InvoicesList";
import Loading from "../../../Loading/Loading";
import SearchBarComp from "../../../SearchBar/SearchBar";
import { checkSpecificPermission } from "../../../../utils/checkPermissions";
import { isAuthenticated } from "../../../Auth/auth";
import { Error } from "../../../Messages/Messages";
import AddInvoices from "../../../Billing/Invoices/AddInvoices";
import { generalErrorAlert } from "../../../GeneralErrorAlert";
import PageToolbar from "../../../../design-system/PageToolbar";

const IndividualMilestoneInvoices = ({ milestone }) => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [data, setData] = useState([]);

  const getData = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/invoices/invoices/filters`,
        {
          project: milestone?.project?._id,
          milestone: milestone?._id,
          inControl: true,
          noMilestone: false,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, [params, searchText, pageNo]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  return (
    <>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          checkSpecificPermission(isAuthenticated()?.roleId?.permissions, "Invoices", "Create") && (
            <AddInvoices
              openModal={false}
              individualMilestone
              updateParent={getData}
              milestone={milestone?._id}
              prefillData={milestone}
            />
          )
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <InvoicesList
          totalCount={totalCount}
          pageSize={pageSize}
          setPageNo={setPageNo}
          pageNo={pageNo}
          data={data}
          updateParent={getData}
        />
      )}
    </>
  );
};

export default IndividualMilestoneInvoices;
